import _ from 'lodash';
import { AssetImageSubtype } from 'src/modules/assets';
import { ProductEntity, ProductSeriesEntity } from 'src/modules/products';
import { ImageEntity } from 'src/modules/global';

export const getProductOverviewImage = (
  product: ProductEntity | ProductSeriesEntity,
  subtype?: AssetImageSubtype
): ImageEntity => {
  if (product.assets) {
    const overviewAsset = product.assets
      .sort((a, b) => (a.sorting < b.sorting ? -1 : 1))
      .filter((asset) =>
        subtype
          ? asset.subtype === subtype
          : asset.subtype === AssetImageSubtype.Cutout ||
            asset.subtype === AssetImageSubtype.Preview
      )[0];
    return overviewAsset ? overviewAsset.file : product.assets?.[0]?.file || null;
  }
  return null;
};

export const isLandscapeAsset = (assets) => {
  const selectedAsset = _.isArray(assets) ? assets[0] : assets;
  if (selectedAsset) {
    const { width, height } = selectedAsset.file || {};
    return width > height ? true : false;
  }
  return false;
};
